import React from 'react'

function OngoingProject() {
  return (
    <div>
        <div className='ongoing'>
            <div className='album py-3'>
                <div className='container'>
           <h1 className='mb-2' style={{color:"#B80000"}}><b>SRG <b className='blink' >Ongoing Project</b></b></h1>
                    <p className='mb-1'><b>Location:</b> SRG Mathpaara (Ready Plot Land Sale) Book Your Dream Land Today!</p>
                    <p>Starting Price: 5.5 Lakh</p>
                    </div>
                </div>
                </div>
    </div>
  )
}

export default OngoingProject